/**
 * Normalize API color strings for SVG/CSS attributes.
 * iOS decodes 8-char #RRGGBBAA hex (e.g. #FFFFFFFF for white) but encodes 6-char #RRGGBB.
 * SVG attribute values should use 6-char hex for broad WKWebView compatibility.
 */
export function normalizeHexForSvg(hex: string): string {
  const trimmed = hex.trim();
  const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
  const body = withHash.slice(1).replace(/[^0-9a-fA-F]/g, "");

  if (body.length === 8) {
    return `#${body.slice(0, 6).toUpperCase()}`;
  }
  if (body.length === 6) {
    return `#${body.toUpperCase()}`;
  }
  if (body.length === 3) {
    const [r, g, b] = [body[0], body[1], body[2]];
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return "#000000";
}
